import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=4a4ba280&scoped=true"
import script from "./bonus.vue?vue&type=script&lang=js"
export * from "./bonus.vue?vue&type=script&lang=js"
import style0 from "./bonus.vue?vue&type=style&index=0&id=4a4ba280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ba280",
  null
  
)

export default component.exports